import { useEffect, useState } from 'react';
import api, { API } from '@/lib/api';

let cached = null;
const listeners = new Set();

export function useCompanySettings() {
  const [cs, setCs] = useState(cached);
  useEffect(() => {
    if (!cached) {
      api.get('/config/company').then(r => {
        cached = r.data; setCs(r.data);
        listeners.forEach(fn => fn(r.data));
      }).catch(() => {});
    }
    const fn = (v) => setCs(v);
    listeners.add(fn); return () => listeners.delete(fn);
  }, []);
  return cs;
}

export function invalidateCompanySettings() {
  cached = null;
  // Broadcast reset so consumers refetch on next mount
  listeners.forEach(fn => fn(null));
}

// Fallback URLs served by the backend from /app/backend/static/
const NEW_PRIMARY_FALLBACK = `${API}/static/ca_official_logo_new.png`;
const COMPACT_GRAY_FALLBACK = `${API}/static/ca_compact_logo_gray.png`;

function _resolve(ref, fallback) {
  if (!ref) return fallback;
  if (ref.startsWith('http://') || ref.startsWith('https://')) return ref;
  if (ref.startsWith('static/')) return `${API}/${ref}`;
  if (ref.startsWith('/api/')) return ref.startsWith('/api/') ? `${API.replace(/\/api$/, '')}${ref}` : ref;
  return `${API}/files/${ref}`;
}

export function logoSrc(cs) {
  return _resolve(cs?.logo_url, NEW_PRIMARY_FALLBACK);
}

export function compactLogoSrc(cs) {
  return _resolve(cs?.compact_logo_url || cs?.logo_url, COMPACT_GRAY_FALLBACK);
}

export function faviconSrc(cs) {
  return _resolve(cs?.favicon_url || cs?.compact_logo_url, COMPACT_GRAY_FALLBACK);
}
